import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';

import { selectActiveTeam, selectActiveTeamPlayerOptions } from 'features/match/matchSlice';

import { selectSelects, inputSliceActions } from 'features/input/inputSlice';

import AdvancedSelect from 'components/AdvancedSelect';
import selectOnChange from './helpers/selectOnChange';

const EventInputDisallowedGoal: React.FC = () => {
  const dispatch = useDispatch();
  const intl = useIntl();

  const team = useSelector(selectActiveTeam);
  const selects = useSelector(selectSelects);
  const playerOptions: any = useSelector(selectActiveTeamPlayerOptions);

  if (!team) return null;

  useEffect(() => {
    dispatch(inputSliceActions.setActiveSelect(selects.goalScorer.id));
  }, []);

  const goalScorerMessage = intl.formatMessage({ id: 'eventInput.player' });

  const onChangeGoal = (option) => {
    selectOnChange(option, team, dispatch, intl);
  };

  return (
    <div className="input-group">
      <div className="section">
        <AdvancedSelect
          title={goalScorerMessage}
          options={playerOptions}
          select={selects.goalScorer}
          isClearable={true}
          onChange={onChangeGoal}
        />
      </div>
    </div>
  );
};

export default EventInputDisallowedGoal;
